import { render, staticRenderFns } from "./ContractSuppliersList.vue?vue&type=template&id=bd0ea6e6&scoped=true&lang=pug&"
import script from "./ContractSuppliersList.vue?vue&type=script&lang=ts&"
export * from "./ContractSuppliersList.vue?vue&type=script&lang=ts&"
import style0 from "./ContractSuppliersList.vue?vue&type=style&index=0&id=bd0ea6e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd0ea6e6",
  null
  
)

export default component.exports